import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useFadeIn } from "@/hooks/useFadeIn";
import aboutImage from "@/assets/about-massachusetts.jpg";

const AboutPreviewSection = () => {
  const { ref, visible } = useFadeIn();

  return (
    <section className="pt-24 pb-20 md:pt-32 md:pb-28 bg-background">
      <div
        ref={ref}
        className={`mx-auto max-w-wide px-5 md:px-12 transition-all duration-700 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="grid grid-cols-1 lg:grid-cols-[1.02fr_0.98fr] gap-12 lg:gap-16 items-center">
          <div className="w-full order-2 lg:order-2">
            <div className="aspect-[4/5] overflow-hidden border border-border/30">
              <img
                src={aboutImage}
                alt="Hadassah Homes team, Massachusetts real estate"
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
          <div className="w-full order-1 lg:order-1 max-w-xl">
            <span className="font-body text-[10px] uppercase tracking-[0.3em] text-accent mb-4 block">
              Our Story
            </span>
            <h2 className="font-headline text-3xl md:text-[2.75rem] lg:text-5xl text-foreground mb-6 leading-[1.1]">
              Meet Hadassah Homes
            </h2>
            <p className="text-muted-foreground text-base md:text-lg leading-[1.8] mb-8">
              Hadassah Homes was built on a mission to educate, empower, and elevate every client we serve. We believe real estate is more than a transaction. It is a pathway to stability, growth, and long-term wealth.
            </p>
            <p className="text-foreground/72 text-sm md:text-base leading-relaxed mb-6">
              Trusted by buyers, sellers, and investors across Massachusetts and the Dominican Republic.
            </p>
            <p className="border-l border-accent pl-4 text-foreground/82 italic text-base leading-relaxed mb-9">
              Trusted guidance rooted in strategy, transparency, and long-term outcomes.
            </p>
            <Button variant="gold" size="lg" className="gap-2.5 text-white px-11 py-[1.05rem] md:px-12 md:py-[1.15rem]" asChild>
              <Link to="/about">
                Learn More
                <ArrowRight className="w-4 h-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreviewSection;
